const normaliseVenueName = (value) => String(value ?? '').trim().toLowerCase();

/**
 * TV logs can be scoped to one venue with the `venue` query parameter. The
 * section leaderboard reports the venue as a display name, and a section whose
 * games are split between venues joins those names with ", ".
 */
export const filterSectionsByVenue = (sections, venueName) => {
  const source = Array.isArray(sections) ? sections : [];
  const target = normaliseVenueName(venueName);
  if (!target) return source;

  return source.filter((section) => {
    const venue = String(section?.venue ?? '').trim();
    if (!venue) return false;
    if (normaliseVenueName(venue) === target) return true;
    return venue.split(',').some((part) => normaliseVenueName(part) === target);
  });
};
